import React, { useState, useEffect } from 'react';
import './MapLoader.css';

const MapLoader = ({ isLoading }) => {
    const [shouldRender, setShouldRender] = useState(isLoading);
    const [fadeOut, setFadeOut] = useState(false);

    useEffect(() => {
        if (isLoading) {
            setShouldRender(true);
            setFadeOut(false);
            return;
        }

        if (!shouldRender) {
            return;
        }

        setFadeOut(true);
        const timer = setTimeout(() => {
            setShouldRender(false);
        }, 1000);

        return () => clearTimeout(timer);
    }, [isLoading, shouldRender]);

    if (!shouldRender) return null;

    return (
        <div className={`map-loader-overlay ${fadeOut ? 'fade-out' : ''}`}>
            <div className="map-loader-container">
                <div className="map-loader-spinner"></div>
                <p className="map-loader-text">Carregando mapa...</p>
            </div>
        </div>
    );
}

export default MapLoader;

